export const formatNumber = (value,options,locale ) => {
  const result = new Intl.NumberFormat(locale || "en-US", {
    maximumFractionDigits: 1,
    ...options,
  }).format(value);
  return isNaN(value) ? value : result;
};

export function formatDuration(seconds) {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  return `${h > 0 ? h + 'h ' : ''}${m > 0 ? m + 'm ' : ''}${s}s`;
}